export default __webpack_public_path__ + "cea435ee35ddd568d2bb56ae5f266276.png";